export default "{\n    \"emptyText\": \"Click to select a category\",\n    \"placeholderText\": \"Search to filter...\",\n    \"newTagLabel\": \"New\"\n}\n"